import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CmsState } from './cms.reducer';

const cmsRootSelector = createFeatureSelector<CmsState>('cms');

const getCmsState = createSelector(cmsRootSelector, (state: CmsState) => state);
const getCmsPagesMap = createSelector(getCmsState, (state) => state.pages);
export const getCmsPageStateByName = (pageName: string) =>
  createSelector(getCmsPagesMap, (pages) => {
    if (!!pages && pageName in pages) {
      return pages[pageName];
    }

    return null;
  });

export const getCmsRef = createSelector(getCmsState, (state) => state.ref);

export const getCmsPageContentByName = (pageName: string) =>
  createSelector(getCmsPageStateByName(pageName), (page) => {
    if (!!page) {
      return page.content;
    }

    return null;
  });

export const getCmsPageLoadingByName = (pageName: string) =>
  createSelector(getCmsPageStateByName(pageName), (page) => {
    if (!!page) {
      return page.loading;
    }
    return false;
  });

export const getCmsPageErrorByName = (pageName: string) =>
  createSelector(getCmsPageStateByName(pageName), (page) => {
    if (!!page) {
      return page.error;
    }
    return null;
  });
